import {Injectable, Pipe, PipeTransform} from "@angular/core";

@Pipe({name:'phoneType'})
@Injectable({
    providedIn: 'root'
})
export class FormatPhoneTypePipe implements PipeTransform {
    // Transforms strings by removing any digits and keeping them capitalized (e.g. HOME1 -> HOME)
    transform(value: string): string {
        if (!value) {
            return '';
        }
        return value.replace(/\d+/g, '').toUpperCase().trim();
    }
}
